module.exports = __webpack_public_path__ + "static/media/IMG_1531.4f48e854.JPG";